import { computed } from 'vue'

import i18n from '@/libs/i18n'

export enum FilterTypes {
    Text        = 1,
    Number      = 2,
    Date        = 3,
    Select      = 4,
    MultiSelect = 5,
    Boolean     = 6,
}

export enum Language {
    English   = 'en',
    Slovenian = 'sl',
}

export enum HomeView {
    Groups   = 'groups',
    Projects = 'projects',
}

const t = (key: string): string => i18n.global.t(key)

export const PredefinedText = computed(() => ({
    AddSuccess:  t('success.add'),
    EditSuccess: t('success.edit'),
    ErrorOnAdd:  t('errors.on_add'),
    ErrorOnEdit: t('errors.on_edit'),
}))
